import { GET_PROGRAM_TYPES } from "constants/programTypes";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_PROGRAM_TYPES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
